import styled from 'styled-components'

export const KnowledgeAroundBoxWrapper = styled.div`
    position: absolute;
    top: ${props => props.position.top};
    right: ${props => props.position.right};
    bottom: ${props => props.position.bottom};
    left: ${props => props.position.left};
    justify-self: center;
    align-self: center;
    
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    @media only screen and (max-width: 768px) {
        width: 100%;
        position: static;
        justify-self: start;
        align-self: start;

        display: block;
        flex-direction: row;
        align-items: center;
        text-align: center;
    }
`